import { escapeHtml } from "./text.ts";

/** Keep scope and commit behavior together, rather than adding badges to every field. */
export function settingsScopeNote(scope: "This device" | "Shared collection" | "Shared space", explanation: string): string {
  return `<p class="settings-scope"><strong>${scope}.</strong> ${escapeHtml(explanation)}</p>`;
}

export function sortOrderHint(id: string): string {
  return `<small id="${escapeHtml(id)}" hidden>Choose a sort field to use ascending or descending order. Manual order uses task positions.</small>`;
}

export function updateSortOrderAvailability(sort: HTMLSelectElement, order: HTMLSelectElement, hint: HTMLElement): void {
  const manual = sort.value === "manual";
  order.disabled = manual;
  hint.hidden = !manual;
  order.setAttribute("aria-describedby", hint.id);
}
